/**
 * MR JERRY — Haptic Feedback (mobile vibration)
 *
 * Ten moduł podpina globalny listener, który wykrywa toast (sonner) i wywołuje
 * krótką wibrację na urządzeniach mobilnych (iOS/Android) używając Vibration API.
 * Zero zmian w call-sites — działa dla wszystkich istniejących toast.success/error/warning.
 *
 * Wibracje:
 *   • success: 30ms
 *   • error:   [40, 60, 40] (dwa krótkie impulsy)
 *   • warning: 60ms
 *   • loading/info: brak (żeby nie irytować przy long-running)
 *
 * Respektuje prefers-reduced-motion — user z preferencjami dostępności nie dostanie wibracji.
 */

const HAPTIC_PATTERNS = {
  success: 30,
  error: [40, 60, 40],
  warning: 60,
};

let started = false;
let lastVibrationAt = 0;
const THROTTLE_MS = 300; // nie wibruj gęściej niż co 300ms

function tryVibrate(pattern) {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return;
  // Respect reduced-motion preference
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (_) { /* ignore */ }
  const now = Date.now();
  if (now - lastVibrationAt < THROTTLE_MS) return;
  lastVibrationAt = now;
  try {
    navigator.vibrate(pattern);
  } catch (_) { /* silently ignore on unsupported devices */ }
}

/**
 * Manual trigger (jeśli chcesz wywołać wibrację bez toasta).
 * Import: import { haptic } from '@/utils/haptics';
 */
export function haptic(type = 'success') {
  const pattern = HAPTIC_PATTERNS[type];
  if (pattern !== undefined) tryVibrate(pattern);
}

/**
 * Startuje globalny listener dla toastów sonner.
 * Wywoływane RAZ z App.js na starcie aplikacji.
 */
export function initGlobalHaptics() {
  if (started) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  // Feature-detect Vibration API — jeśli brak, nawet nie startujemy observera.
  if (typeof navigator.vibrate !== 'function') return;

  started = true;

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        // Sonner renderuje toast jako <li data-sonner-toast ... data-type="success">
        const isToast = node.matches?.('[data-sonner-toast]') ||
          node.querySelector?.('[data-sonner-toast]');
        if (!isToast) continue;
        const el = node.matches?.('[data-sonner-toast]') ? node : node.querySelector('[data-sonner-toast]');
        const type = el?.getAttribute('data-type') || 'success';
        haptic(type);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
